import { Component, inject } from '@angular/core';
import { CostReceiverTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CostReceiverTypeCreateDto,
  CostReceiverTypeDto,
  CostReceiverTypeExcelDownloadDto,
  CostReceiverTypeUpdateDto,
} from '../proxy/controlling/dtos/cost-receiver-type';
import { COST_RECEIVER_TYPE_CONFIG, COST_RECEIVER_TYPE_FIELDS } from './cost-receiver-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-cost-receiver-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, CostReceiverTypeService, ConfirmationService],
  templateUrl: './cost-receiver-type.html',
  styleUrl: './cost-receiver-type.scss',
})
export class CostReceiverType extends BaseCrudComponent<
  CostReceiverTypeDto,
  CostReceiverTypeCreateDto,
  CostReceiverTypeUpdateDto,
  CostReceiverTypeExcelDownloadDto
> {
  service = inject(CostReceiverTypeService);
  config = COST_RECEIVER_TYPE_CONFIG;
  fields = COST_RECEIVER_TYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: CostReceiverTypeDto): CostReceiverTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'CostReceiverType';
  }
}
